import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import rotevatnImg from "@/assets/rotevatn.webp";
import { useLanguage, translations } from "@/i18n/LanguageContext";

const QuoteSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const { t } = useLanguage();

  return (
    <section ref={ref} className="section-padding py-24 md:py-36 bg-card">
      <div className="max-w-5xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={isInView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }} className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
          <div className="flex-shrink-0">
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl overflow-hidden border-[3px] border-background shadow-lg ring-1 ring-border">
              <img src={rotevatnImg} alt="Sveinung Rotevatn" className="w-full h-full object-cover"  loading="lazy" decoding="async" />
            </div>
          </div>
          <div>
            <blockquote className="heading-md text-foreground text-balance mb-8 relative">
              <span className="absolute -top-6 -left-4 text-6xl text-primary/20 font-display leading-none">"</span>
              {t(translations.quote.text)}
            </blockquote>
            <div>
              <p className="font-display font-600 text-foreground text-sm">{t(translations.quote.name)}</p>
              <p className="text-xs font-body text-muted-foreground mt-0.5">{t(translations.quote.title)}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default QuoteSection;
